var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"help-button",on:{"click":function($event){return _vm.openSupportArticle()}}},[_c('i',{staticClass:"ri-question-line",staticStyle:{"color":"#666666"}}),_c('span',[_vm._v("Help")])])
}
var staticRenderFns = []

export { render, staticRenderFns }